<header class="alert-header">
    <div class="hospital-name">
        <h2>{{this.healthUnitName}}</h2>
        <h3 *ngIf="nameRoom">Chamando</h3>
        <p *ngIf="nameRoom">Dirija-se a: {{nameRoom}}</p>
    </div>
</header>